// jscs:disable requireCamelCaseOrUpperCaseIdentifiers
import en_CA from './en_CA';
import en_US from './en_US';
import en_GB from './en_GB';
import fr_CA from './fr_CA';
import fr_FR from './fr_FR';
import pt_PT from './pt_PT';
import tr_TR from './tr_TR';
import el_GR from './el_GR';
import sr_RS from './sr_RS';
import fr_BE from './fr_BE';
import nl_BE from './nl_BE';
import es_MX from './es_MX';
import fr_MA from './fr_MA';
import sk_SK from './sk_SK';
import es_ES from './es_ES';
import pt_BR from './pt_BR';
import fi_FI from './fi_FI';
import es_CO from './es_CO';
import sv_SE from './sv_SE';
import hy_AM from './hy_AM';
export default {
    en_CA,
    en_US,
    en_GB,
    fr_CA,
    fr_FR,
    pt_PT,
    tr_TR,
    el_GR,
    sr_RS,
    fr_BE,
    nl_BE,
    es_MX,
    fr_MA,
    sk_SK,
    es_ES,
    pt_BR,
    fi_FI,
    es_CO,
    sv_SE,
    hy_AM
};



// WEBPACK FOOTER //
// ./src/localization/index.js